import isCypress from '@signal/utils/env/isCypress';
export var props = {
  MuiButtonBase: {
    disableRipple: isCypress()
  }
};
export default props;